import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
// 图标组件，注册到公共组件中
import 'remixicon/fonts/remixicon.css'
import http from '@/ajax/http'

Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$http = http

Vue.prototype.$projectPath = `${process.env.VUE_APP_PUBLIC_PATH}assets/project/${process.env.VUE_APP_PAGE_MODE}`

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
